module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ro22FJ/tc-custom/9781646567980.jpg?1723592038250",
      "alt": "This image is the cover for the book Leap of Faith"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Leap of Faith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Abseiling? How did Anika persuade her to do that? When Lauren set out to start her life over -- new job, new city, new friends -- she never dreamed she’d be clinging to a rope, dangling off a ninety-foot railway viaduct. Then again, she’d never expected to meet someone like Anika."), _c('br'), _c('br'), _vm._v("Determined to rebuild her confidence and regain independence after the devastation of a shattering break-up, Lauren was surprised to be drawn to Anika. Headstrong and daring, Anika was fascinating and yet, intimidating -- not Lauren’s usual type. Their unexpected friendship was like a breath of fresh air ... Could it be more? With the painful past still raw, was it too soon to love again? Was Lauren merely rebounding?"), _c('br'), _c('br'), _vm._v("In the midst of bravely tackling the challenging abseil, Lauren had a decision to make. Play safe or throw caution to the wind? Is she prepared to take a leap of faith?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mags Hayward\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0